import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "aos/dist/aos.css";
import AOS from "aos";
import "./RegulationsPolicy.css";
import Footer from "../Home/Footer";
import RegulationSlider1 from "../assets/img/RegulationSlider-1.jpg";

const RegulationsPolicy = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const regulationsData = [
    {
      title: "Soybean Trade Regulations",
      description:
        "Regulations governing domestic and international soybean trade to ensure fair practices and sustainability.",
      icon: "fas fa-gavel",
    },
    {
      title: "Environmental Policies",
      description:
        "Guidelines for sustainable soybean farming to protect natural resources and reduce carbon footprint.",
      icon: "fas fa-leaf",
    },
    {
      title: "Certification & Compliance",
      description:
        "Mandatory certifications for soybean growers, exporters, and processors.",
      icon: "fas fa-certificate",
    },
    {
      title: "Import & Export Policies",
      description:
        "Regulatory framework for soybean import/export to maintain global trade standards.",
      icon: "fas fa-globe",
    },
    {
      title: "Subsidies & Government Support",
      description:
        "Government schemes, subsidies, and financial support for soybean farmers.",
      icon: "fas fa-hand-holding-usd",
    },
  ];

  return (
    // <div className="regulations-policy-page">
    //   {/* Hero Section */}
    //   <section
    //     className="hero-section-policy"
    //     style={{
    //       backgroundImage: `url(${RegulationSlider1})`,
    //     }}
    //   >
    //     <div className="overlay"></div>
    //     <div className="container text-center">
    //       <h1 data-aos="fade-down" className="hero-title">
    //         Regulations & Policies
    //       </h1>
    //       <p data-aos="fade-up" className="hero-description">
    //         Stay informed about the latest policies, regulations, and
    //         certifications governing soybean farming and trade.
    //       </p>
    //     </div>
    //   </section>

    //   {/* Key Policies Section */}
    //   <section className="policies-section container">
    //     <h2 className="regulations-section-title" data-aos="fade-up">
    //       Key Regulations
    //     </h2>
    //     <div className="policies-grid">
    //       {regulationsData.map((policy, index) => (
    //         <div key={index} className="policy-card" data-aos="zoom-in">
    //           <i className={policy.icon}></i>
    //           <h3>{policy.title}</h3>
    //           <p>{policy.description}</p>
    //         </div>
    //       ))}
    //     </div>
    //   </section>

    //   {/* Legal Framework & Acts */}
    //   <section className="legal-framework-section container">
    //     <h2 className="regulations-section-title" data-aos="fade-up">
    //       Legal Framework & Acts
    //     </h2>
    //     <p data-aos="fade-right">
    //       Several acts and legal provisions regulate soybean production,
    //       processing, and trade. Key legislations include:
    //     </p>
    //     <ul data-aos="fade-left">
    //       <li>Agricultural Produce Market Committee (APMC) Act</li>
    //       <li>Food Safety & Standards Act (FSSAI)</li>
    //       <li>Essential Commodities Act</li>
    //       <li>Environment Protection Act</li>
    //     </ul>
    //   </section>

    //   {/* Government Guidelines & Support */}
    //   <section className="govt-guidelines-section container">
    //     <h2 className="regulations-section-title" data-aos="fade-up">
    //       Government Guidelines & Support
    //     </h2>
    //     <p data-aos="fade-right">
    //       The government offers various programs and guidelines to support
    //       soybean farmers:
    //     </p>
    //     <ul data-aos="fade-left">
    //       <li>Minimum Support Price (MSP) for Soybean</li>
    //       <li>Subsidies for organic farming</li>
    //       <li>Financial aid for small-scale farmers</li>
    //       <li>Training programs on sustainable farming</li>
    //     </ul>
    //   </section>

    //   {/* Enforcement & Penalties */}
    //   <section className="enforcement-section container">
    //     <h2 className="regulations-section-title" data-aos="fade-up">
    //       Enforcement & Penalties
    //     </h2>
    //     <p data-aos="fade-right">
    //       To ensure compliance, penalties for violations include:
    //     </p>
    //     <ul data-aos="fade-left">
    //       <li>Fines for pesticide overuse</li>
    //       <li>License cancellation for non-compliance</li>
    //       <li>Legal actions for fraudulent soybean certification</li>
    //     </ul>
    //   </section>

    //   {/* Case Studies & Reports */}
    //   <section className="case-studies-section container">
    //     <h2 className="regulations-section-title" data-aos="fade-up">
    //       Case Studies & Reports
    //     </h2>
    //     <p data-aos="fade-right">
    //       Explore real-world cases of successful regulatory implementation in
    //       the soybean industry.
    //     </p>
    //     <div className="case-study">
    //       <h3 data-aos="fade-left">
    //         Case Study: Impact of Organic Certification
    //       </h3>
    //       <p data-aos="fade-right">
    //         Farmers adopting organic certification saw a 20% increase in
    //         international trade opportunities.
    //       </p>
    //     </div>
    //   </section>

    //   {/* Compliance & Certifications */}
    //   <section className="compliance-section container">
    //     <h2
    //       className="regulations-section-title"
    //       data-aos="fade-up"
    //       style={{ color: "#d4561a" }}
    //     >
    //       Compliance & Certifications
    //     </h2>
    //     <div className="compliance-content" data-aos="fade-right">
    //       <p>
    //         To ensure the highest quality standards, soybean farmers and traders
    //         must comply with national and international certifications.
    //       </p>
    //       <ul>
    //         <li>Organic Soybean Certification</li>
    //         <li>Global GAP Certification</li>
    //         <li>ISO 22000: Food Safety Standards</li>
    //         <li>Non-GMO Certification</li>
    //         <li>EU & US Soybean Export Compliance</li>
    //       </ul>
    //     </div>
    //   </section>

    //   {/* Downloadable Documents */}
    //   <section className="downloads-section container">
    //     <h2 className="regulations-section-title" data-aos="fade-up">
    //       Download Important Documents
    //     </h2>
    //     <div className="download-links">
    //       <a href="/docs/soybean_trade_policy.pdf" className="download-btn">
    //         <i className="fas fa-file-pdf"></i> Trade Policy PDF
    //       </a>
    //       <a
    //         href="/docs/soybean_certification_guidelines.pdf"
    //         className="download-btn"
    //       >
    //         <i className="fas fa-file-pdf"></i> Certification Guidelines PDF
    //       </a>
    //       <a href="/docs/environmental_policies.pdf" className="download-btn">
    //         <i className="fas fa-file-pdf"></i> Environmental Policies PDF
    //       </a>
    //     </div>
    //   </section>
    //   <Footer />
    // </div>
    <section id="recent-posts" className="recent-posts section">
      <div className="container">
        <div className="row justify-content-center text-center">
          <div className="col-lg-8">
            <div
              className="p-5 rounded shadow"
              style={{ backgroundColor: "#fff8e1" }}
            >
              <h2
                className="mb-3"
                style={{ fontSize: "2rem", color: "#ff6f00" }}
              >
                🚧 Coming Soon
              </h2>
              <p style={{ fontSize: "1.1rem", color: "#555" }}>
                This section is under construction. Stay tuned for our latest
                posts and updates!
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RegulationsPolicy;
